import { useQuery } from "@apollo/client";
import { createContext, useContext, useEffect, useState } from "react";
import { GET_USER_ACCESS } from "../../Graphql/queries";

const basePermissionContext = createContext({
  userPermissionAccess: {
    allow_qr_code: true,
    allow_custom_task: 10,
  },
});
const { Provider, Consumer } = basePermissionContext;

const PermissionProvider = ({ children }) => {
  const { data } = useQuery(GET_USER_ACCESS, {
    variables: { user_id: localStorage.getItem("user_id") },
  });
  const [userAccess, setUserAccess] = useState({
    allow_qr_code: false,
    allow_custom_task: 10,
    user_name: "",
    user_email: "",
    user_id: "",
  });
  useEffect(() => {
    if (
      !!data &&
      data?.getUsersById?.user_location_maps[0]?.businessDetails?.owner
        ?.userSubscription?.package_price
    ) {
      setUserAccess({
        allow_qr_code:
          data?.getUsersById?.user_location_maps[0]?.businessDetails?.owner
            ?.userSubscription?.package_price?.package?.allow_qr_code,
        allow_custom_task:
          data?.getUsersById?.user_location_maps[0]?.businessDetails?.owner
            ?.userSubscription?.package_price?.package?.allow_custom_task,
        user_name: data?.getUsersById?.full_name,
        user_email: data?.getUsersById?.email,
        user_id: data?.getUsersById?.user_id,
      });
    }
  }, [data]);

  return (
    <Provider
      value={{
        userPermissionAccess: userAccess,
      }}
    >
      {children}
    </Provider>
  );
};

const usePermissionUser = () => useContext(basePermissionContext);

export {
  Consumer as PermissionConsumer,
  PermissionProvider,
  usePermissionUser,
};
